module.exports = __webpack_public_path__ + "static/img/b3-1.d07df47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b3-1.png
// module id = W9vp
// module chunks = 1